import { getAppLanguage } from "./localStorageService";

const getFormattedData = (list, recommendationUserId) => {
  let data = {};
  var contentList = [];
  const content = list?.recomms;
  const appLanguage = getAppLanguage() + "";
  const appLang = appLanguage.toLowerCase().replace("-", "_");
  const currentUserLocation = localStorage.getItem("country_code") + "";
  const countryLocation = currentUserLocation.toLowerCase().replace("-", "_");
  if (content) {
    content.map((item, index) => {
      const { values } = item || {};
      const {
        uid,
        type,
        first_trailer_stream,
        display_duration,
        display_tag = "new",
        download_url,
        streams,
        actor_list_en_us,
        // title_en_us,
        short_description_en_us,
        season_uid,
        available_on_id,
        available_till_id,
        description_en_us,
        supported_countries,
        genre_en_us,
        director_list_en_us,
        // default_image_portrait_en_us,
        parental_control_id,
        is_cc_available,
        purchase_mode,
        release_year,
        // default_image_landscape_en_us,
        // ---------
        title,
        // default_image_landscape,
        default_image_portrait,
      } = values;
      const trailerSet = [{ streams: first_trailer_stream }];
      const imagesSet = [
        {
          height: 360,
          type: "landscape",
          url: default_image_portrait, // Fix here
          width: 640,
        },

        {
          height: 270,
          type: "portrait",
          url: default_image_portrait,
          width: 152,
        },
      ];
      const displayTag = display_tag === "" ? "new" : display_tag;
      const parentalRating = [
        {
          rating: values[`parental_control_${countryLocation}`] || parental_control_id,
        },
      ];
      data = {
        actor: values[`actor_list_${appLang}`] || actor_list_en_us,
        // availableDays: "",
        availableOn: values[`available_on_${countryLocation}`] || available_on_id,
        availableTill: values[`available_till_${countryLocation}`] || available_till_id,
        categoryId: "",
        // contentGuid,
        countries: supported_countries,
        director: values[`director_list_${appLang}`] || director_list_en_us,
        displayDuration: display_duration,
        displayTag: displayTag,
        downloadUrl: download_url,
        // episodeNumber,
        genre: values[`genre_${appLang}`] || genre_en_us,
        images: imagesSet,
        // isCastable,
        isCcAvailable: is_cc_available,
        // isDownloadable,
        // maxQualityAvailable,
        // mediaGuid,
        parentalControl: parentalRating,
        purchaseMode: purchase_mode,
        releaseYear: release_year,
        seasonUid: season_uid,
        shortDescription: values[`short_description_${appLang}`] || short_description_en_us,
        description: values[`description_${appLang}`] || description_en_us,
        streams: streams,
        studio: [],
        tags: [],
        title: title,
        trailers: trailerSet,
        type,
        uid,
        recommendation_id: list?.recommId,
        recommendationUserId,
      };
      return contentList.push(data);
    });
  }

  return { contentList };
};

export default getFormattedData;

export function extractParameterValue(paramName = "", paramsString = "") {
  const regex = new RegExp(`${paramName}=([^,]+)`);
  const match = paramsString.match(regex);
  return match ? match[1] : null;
}
